"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("exportConfig", () => ({
    restrict: "E",
    templateUrl: "app/admin/company/dataexport/export-config.html",
    controller: "ExportConfigCtrl",

    scope: {
      isOpen: "=",
      selectedItem: "=",
      onApply: "=",
    },
  }))
